<div class="case-create-styles">
  <div class="mx-5 mb-3 d-flex flex-column">
    <div class="mr-3 font-size-18 font-text-bold">Case Information</div>
    <p class="pl-3 font-sm-size">Please complete the form below to create a case. All fields marked with an <i class="fas fa-xs fa-asterisk text-danger"></i> are required</p>

    <div class="d-flex pr-2">
      <div class="mr-4">
        @if (orderUrlObject?.orderNumber) {
          <div class="font-sm-size font-text-bold">Sales Order#</div>
          <div class="font-sm-size">{{this.orderNumber}}</div>
        }
        @if (invoiceUrlObject?.documentNumber) {
          <div class="d-flex">
            <div >
              <div class="font-sm-size font-text-bold">Invoice No#</div>
              <div class="font-sm-size">{{invoiceUrlObject?.documentNumber}}</div>
            </div>
            @if (orderNumber) {
              <div class="ml-4">
                <div class="font-sm-size font-text-bold">Sales Order#</div>
                <div class="font-sm-size">{{this.orderNumber}}</div>
              </div>
            }
          </div>
        }
      </div>
      <div>
        @if (jobName) {
          <div class=" font-sm-size font-text-bold">Job Name</div>
        }
        <div class="font-sm-size">{{this.jobName}}</div>
      </div>
    </div>
    <div class="login-forms">
      <hr class="mt-3 col-lg-9 float-left">
    </div>

    <div [formGroup]="helperForm">
      @if (caseFromInvoice === false) {
        <div class="login-forms col-lg-12">
          <div class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
            <ng-select class="mb-1" formControlName="orderBaseDocumentNumber" [items]="invoicesForTheOrder" [placeholder]="'Select Value'"
              [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" (change)='onInvoiceSelectionChange()'>
            </ng-select>
            <label class="text-muted">Invoice Selection<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
            <p class="warning mb-0">Note: Changing the Invoice# Selection, will reset the form</p>
          </div>
        </div>
      }
      @if ((caseFromInvoice === false && helperForm.get('orderBaseDocumentNumber')?.value) || (caseFromInvoice === true)) {
        <div class="login-forms col-lg-12">
          <h4 class="font-sm-size font-text-bold">Select Case Type</h4>
          <div class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
            <ng-select class="mb-1" formControlName="proxyCaseType" [items]="caseTypesData" [placeholder]="'Select Value'"
              [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" (change)='onCaseTypeChange($event)'>
            </ng-select>
            <label class="text-muted">Select Subject/Case Type<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
            <p class="warning mb-0">Note: Changing the Case Type, will reset the form</p>
          </div>
        </div>
      }
    </div>

    <ng-container [formGroup]="caseCreationForm" >
      <div class="login-forms col-lg-12">
        @if (showIssueType) {
          <div class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
            <ng-select class="mb-1" formControlName="issueType" [items]="issueTypesData" [placeholder]="'Select Value'"
              [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" (change)='onIssueTypeChange($event)'>
            </ng-select>
            <span class="highlight"></span>
            <label class="text-muted">Case Reason<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
            @if (submitted && caseCreationForm.get('issueType') && caseCreationForm.get('issueType').errors) {
              <div>
                <small class="text-danger">
                  Issue Type is required
                </small>
              </div>
            }
          </div>
        }
        @if (showIssueSubType) {
          <div class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
            <ng-select class="mb-1" formControlName="issueSubType" [items]="issueSubTypesData" [placeholder]="'Select Value'"
              [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" (change)='onSubIssueTypeChange($event)'>
            </ng-select>
            <span class="highlight"></span>
            <label class="text-muted">Specific Reason for Case<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
            @if (submitted && caseCreationForm.get('issueSubType').touched && caseCreationForm.get('issueSubType').errors) {
              <div>
                <small class="text-danger">
                  Issue Sub Type is required
                </small>
              </div>
            }
          </div>
        }
      </div>

      @if (showIncidentDate || showCaseDesc) {
        <div class="font-sm-size font-text-bold">Case Details</div>
      }
      @if (showIncidentDate) {
        <div class="col-12 login-forms customersearch-forms">
          <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-2 p-res-0 valid-to">
            <div class="input-group">
              <input class="form-control w-100 mb-0" [placeholder]="'Date of Incident'"
                name="incidentDate" ngbDatepicker #incidentDate="ngbDatepicker" formControlName="incidentDate" [readonly]="true"
                [maxDate]="maxStartDate()" />
                <span class="highlight"></span>
                <label class="text-muted">Date of Event</label>
                <div class="input-group-append">
                  <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="incidentDate.toggle()"
                    type="button">
                    <i class="far fa-calendar-alt color-font header-icon-color"></i>
                  </button>
                </div>
              </div>
            </div>
            @if (showCaseDesc) {
              <div>
                <div class="form-group mt-3 col-lg-6 pl-0 float-left p-res-0 custom-height">
                  <textarea type="text" class="form-control w-100" placeholder="Enter Description" formControlName="caseDescription"></textarea>
                  <span class="highlight"></span>
                  <label class="text-muted">Case Description<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
                  @if (caseCreationForm.get('caseDescription') && caseCreationForm.get('caseDescription').errors?.maxlength) {
                    <div>
                      <small class="text-danger">
                        Can't be more than 512 characters
                      </small>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }

        <!-- Additional Details section goes here (only one type) -->
        <ng-container >
          <div>
            @if (showAdditionalDetails) {
              <div class="font-sm-size font-text-bold">Issue Details</div>
            }
            <div class="col-lg-12 login-forms">
              @if (showShipmentNumber) {
                <div class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
                  <span class="highlight"></span>
                  <label class="text-muted">Shipment#</label>
                  <ng-select class="mb-1" formControlName="shipmentNumber" [items]="shipmentResponseData" [placeholder]="'Select Value'"
                    [searchable]="true" [clearable]="true" [addTag]="addCustomOption" bindLabel="name" bindValue="value" >
                  </ng-select>
                </div>
              }
            </div>

            <!-- <div *ngIf="showClaimCheckbox" class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
            <div class="form-check freight-claim">
              <input type="checkbox" class="mb-2 form-check-input" id="newCheckbox" (click)="openClaimForm($event)" formControlName="fileFreightClaim">
              <label class="text-muted" for="newCheckbox">File Freight Claim?</label>
            </div>
          </div> -->

          @if (false) {
            <div class="col-12 login-forms">
              <h4 class="font-sm-size font-text-bold">Freight Claim Information</h4>
              <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                <!-- Row 1 -->
                <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                  <input type="text" class="form-control w-100" formControlName="Plant"/>
                  <span class="highlight"></span>
                  <label class="text-muted">Plant Name</label>
                </div>
                <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0 valid-to">
                  <div class="input-group">
                    <input class="form-control w-100 mb-0"  name="ShipDate" ngbDatepicker
                      #ShipDate="ngbDatepicker" formControlName="ShipDate" [readonly]="true" [maxDate]="maxStartDate()" />
                      <span class="highlight"></span>
                      <label class="text-muted">Shipment Date</label>
                    </div>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" formControlName="CarrierName"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Carrier Name</label>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" formControlName="CarrierNumber"/>
                    <span class="highlight"></span>
                    <label class="text-muted">SAP Carrier Number</label>
                  </div>
                </div>
                <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                  <!-- Row 2 -->
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" formControlName="DestCity"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Destination City</label>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" formControlName="DestState"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Destination State</label>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" formControlName="DestZipcode"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Destination Zip</label>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" formControlName="claimAmount"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Claim Amount</label>
                  </div>
                </div>
                <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                  <!-- Row 3 -->
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" placeholder="Enter Contact" maxlength="30" formControlName="contact"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Contact</label>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <label class="text-muted radio-label">Claim Status</label>
                    <div class="radio-group">
                      @for (option of claimStatusOptions; track option) {
                        <div class="radio-option">
                          <input type="radio" class="radio-input" [id]="'claimStatus' + option.value" [value]="option.value" formControlName="claimStatus" />
                          <p>{{ option.label }}</p>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <label class="text-muted radio-label">Damage Claim?</label>
                    <div class="radio-group">
                      @for (option of yesNoOptions; track option) {
                        <div class="radio-option">
                          <input type="radio" class="radio-input" [id]="'damageClaim' + option.value" [value]="option.value" formControlName="damageClaim" />
                          <p>{{ option.label }}</p>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <label class="text-muted radio-label">Loss Claim</label>
                    <div class="radio-group">
                      @for (option of yesNoOptions; track option) {
                        <div class="radio-option">
                          <input type="radio" class="radio-input" [id]="'lossClaim' + option.value" [value]="option.value" formControlName="lossClaim" />
                          <p>{{ option.label }}</p>
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                  <!-- Row 4 -->
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                    <input type="text" class="form-control w-100" placeholder="Enter Value" maxlength="20" formControlName="claimNumber"/>
                    <span class="highlight"></span>
                    <label class="text-muted">Claim Number</label>
                  </div>
                  <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0 valid-to">
                    <div class="input-group">
                      <input class="form-control w-100 mb-0" placeholder="File Date"
                        name="fileDate" ngbDatepicker #fileDate="ngbDatepicker" formControlName="fileDate" [readonly]="true" [maxDate]="maxStartDate()" />
                        <span class="highlight"></span>
                        <label class="text-muted">File Date</label>
                        <div class="input-group-append">
                          <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="fileDate.toggle()" type="button">
                            <i class="far fa-calendar-alt color-font header-icon-color"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0 valid-to">
                      <div class="input-group">
                        <input class="form-control w-100 mb-0" placeholder="Settle/Decline Date"
                          name="settleOrDeclineDate" ngbDatepicker #settleOrDeclineDate="ngbDatepicker" formControlName="settleOrDeclineDate" [readonly]="true" [maxDate]="maxStartDate()" />
                          <span class="highlight"></span>
                          <label class="text-muted">Settle or Decline Date</label>
                          <div class="input-group-append">
                            <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="settleOrDeclineDate.toggle()" type="button">
                              <i class="far fa-calendar-alt color-font header-icon-color"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                        <input type="text" class="form-control w-100" placeholder="Enter Value" maxlength="" formControlName="settleAmount"/>
                        <span class="highlight"></span>
                        <label class="text-muted">Settle Amount</label>
                      </div>
                    </div>
                    <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                      <!-- Row 5 -->
                      <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                        <input type="text" class="form-control w-100" placeholder="Enter Value" formControlName="plantOwner"/>
                        <span class="highlight"></span>
                        <label class="text-muted">Owner</label>
                      </div>
                      <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                        <input type="text" class="form-control w-100" placeholder="Enter Value" formControlName="noOfDaysPassed"/>
                        <span class="highlight"></span>
                        <label class="text-muted">Number of Days Passed</label>
                      </div>
                      <div class="form-group mt-3 col-lg-6 pl-0 float-left mb-3 p-res-0 custom-height">
                        <textarea type="text" class="form-control w-100" placeholder="Enter Remark" maxlength="250" formControlName="remark"></textarea>
                        <span class="highlight"></span>
                        <label class="text-muted">Remark</label>
                      </div>
                    </div>
                    <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                      <!-- Remark textarea -->
                      <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0 valid-to">
                        <div class="input-group">
                          <input class="form-control w-100 mb-0" placeholder="Check Received Date"
                            name="checkReceivedDate" ngbDatepicker #checkReceivedDate="ngbDatepicker" formControlName="checkReceivedDate" [readonly]="true" [maxDate]="maxStartDate()" />
                            <span class="highlight"></span>
                            <label class="text-muted">Check Received Date</label>
                            <div class="input-group-append">
                              <button class="btn btn calendar p-0 h-auto w-auto" container="body" (click)="checkReceivedDate.toggle()" type="button">
                                <i class="far fa-calendar-alt color-font header-icon-color"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                          <input type="text" class="form-control w-100" placeholder="Enter Value" formControlName="checkNumber"/>
                          <span class="highlight"></span>
                          <label class="text-muted">Check Number</label>
                        </div>
                      </div>
                    </div>
                  }
                  @if (showMultiSelectProducts) {
                    <div class="col-md-12 col-12 customersearch-forms login-forms p-0 customer-home-forms">
                      <div class="form-group mt-3 col-lg-6 pl-0 float-left mb-3 p-res-0 multi-select-styles">
                        <ng-select  [items]="this.productsData" [clearSearchOnAdd]="true"
                          [closeOnSelect]="false" labelForId="state" [multiple]="true"  [placeholder]="'Product'"
                          clearAllText="Clear" formControlName="multiSelectProducts" [bindLabel]="'labelDescription'" [ngModel]="multipleSelectedProducts" (change)="onMultiSelectProductChange($event)">
                          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <div class="row">
                              <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"    [ngModelOptions]="{standalone: true}" />
                              {{item['labelDescription']}}
                            </div>
                          </ng-template>
                          <ng-template ng-multi-label-tmp let-items="items">
                            @for (item of items | slice:0:1; track item) {
                              <div class="ng-value">
                                {{item['labelDescription']}}
                              </div>
                            }
                            @if (items.length > 1) {
                              <div class="ng-value">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                              </div>
                            }
                          </ng-template>
                        </ng-select>
                        <span class="highlight"></span>
                        <label class="text-muted">Product@if (caseCreationForm.get('multiSelectProducts')?.validator) {
                          <i class="fas fa-xs fa-asterisk text-danger pl-1"></i>
                        }</label>
                      </div>
                    </div>
                  }
                  @if (showMultiSelectProducts && multipleSelectedProducts.length) {
                    <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                      <h4 class="font-sm-size col-12">Selected List of Products</h4>
                      @for (item of multipleSelectedProducts; track item) {
                        <div>
                          <div class="d-flex col-lg-10">
                            <div class="mt-2 col-lg-5 col-6">{{item.labelDescription}}</div>
                            <div class="form-group pl-0 float-left p-res-0 col-lg-2 col-2">
                              <input type="text" class="form-control w-100" placeholder="Enter Value" (input)="quantityChangeAfterMultiSelect($event, item)"/>
                              <span class="highlight"></span>
                              <label class="text-muted">{{getQuantityLabelName()}}</label>
                            </div>
                            <div class="form-group col-lg-2 pl-0 float-left p-res-0">
                              <ng-select class="mb-1" [items]="alternateUomData[item.code]" [placeholder]="'Select Value'"
                                [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" (change)='uomChangeAfterMultiSelect($event, item)'>
                              </ng-select>
                              <span class="highlight"></span>
                              <label class="text-muted">UOM</label>
                            </div>
                            <div class="mt-2 col-lg-1 col-1 ml-3 removeIcon" (click)="removeTheSelectedItem(item.code)">
                              <img src="images/close-icon-upload.svg" class="pb-1">
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }


                  @if (showProducts) {
                    <div  class="login-forms col-lg-12">
                      <div class="form-group col-lg-3 pl-0 float-left mb-3 p-res-0 mt-3">
                        <ng-select class="mb-1" formControlName="products" [items]="this.productsData"
                          [placeholder]="'Select Value'" [searchable]="false" [clearable]="false"
                          bindLabel="labelDescription" bindValue="code" (change)='onProductChange()'>
                        </ng-select>
                        <span class="highlight"></span>
                        <label class="text-muted">Product@if (caseCreationForm.get('products')?.validator) {
                          <i class="fas fa-xs fa-asterisk text-danger pl-1"></i>
                        }</label>
                      </div>
                    </div>
                  }

                  <div class="col-lg-6 float-left customersearch-forms login-forms p-0 customer-home-forms">
                    @if (showRequestedSku) {
                      <div class="form-group mt-3 col-lg-6 pl-0 float-left mb-3 p-res-0">
                        <ng-select class="mb-1" formControlName="requestedSku" [items]="this.productsData"
                          [placeholder]="'Select Value'" [searchable]="false" [clearable]="false"
                          bindLabel="labelDescription" bindValue="code" (change)="handleRequestedSkuSelection($event)">
                        </ng-select>
                        <span class="highlight"></span>
                        <label class="text-muted">Requested SKU<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
                        @if (submitted && caseCreationForm.get('requestedSku') && caseCreationForm.get('requestedSku').errors) {
                          <div>
                            <small class="text-danger">
                              Requested SKU is required
                            </small>
                          </div>
                        }
                      </div>
                    }
                    @if (showDeliveredSku) {
                      <div class="form-group mt-3 col-lg-6 pl-0 float-left mb-3 p-res-0">
                        <ng-select
                          [items]="options$ | async"
                          [searchable]="true"
                          [clearable]="true"
                          [typeahead]="caseCreationForm.get('deliveredSku')!.valueChanges"
                          bindLabel="description"
                          formControlName="deliveredSku"
                          placeholder="Start typing to search"
                          notFoundText="No results found"
                          bindValue="code"
                          (change)="handleSelectedDeliveredsku($event)"
                        ></ng-select>
                        <span class="highlight"></span>
                        <label class="text-muted">Delivered SKU<i class="fas fa-xs fa-asterisk text-danger pl-1"></i></label>
                        @if (submitted && caseCreationForm.get('deliveredSku') && caseCreationForm.get('deliveredSku').errors) {
                          <div>
                            <small class="text-danger">
                              Delivered SKU is required
                            </small>
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="col-lg-12 float-left customersearch-forms login-forms p-0 customer-home-forms">
                    @if (showBatchNumber) {
                      <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                        <input type="text" class="form-control w-100" placeholder="Enter Value" formControlName="batchNumber"/>
                        <span class="highlight"></span>
                        <label class="text-muted">Batch/Lot#</label>
                      </div>
                    }
                    @if (showQuantity) {
                      <div class="form-group mt-3 col-lg-3 pl-0 float-left mb-3 p-res-0">
                        <input type="text" class="form-control w-100" placeholder="Enter Value" formControlName="quantity" />
                        <span class="highlight"></span>
                        <label class="text-muted">{{getQuantityLabelName()}}</label>
                      </div>
                    }
                    @if (showQuantity) {
                      <div class="form-group mt-3 col-lg-2 pl-0 float-left p-res-0">
                        <ng-select class="mb-1" [items]="alternateUomData[getSingleSelectedProductValue()]" [placeholder]="'Select Value'"
                          [searchable]="false" [clearable]="false" bindLabel="name" bindValue="value" formControlName="uom">
                        </ng-select>
                        <span class="highlight"></span>
                        <label class="text-muted">UOM</label>
                      </div>
                    }
                  </div>
                </div>
              </ng-container>

              @if (showUploadFileSection) {
                <h4 class="font-sm-size font-text-bold mb-3">Upload Documents</h4>
                <div class="col-lg-6 pl-0">
                  <div [ngClass]="uploadedFileObjects.length > 0 ? 'border' : '' ">
                    <div class="col-12 d-flex upload-background file-drop-area" [ngClass]="uploadedFileObjects.length === 0 ? 'border' : ''"
                      (dragover)="onDragOver($event)"
                      (dragleave)="onDragLeave($event)"
                      (drop)="onDrop($event)"
                      [class.drag-over]="isDragOver">
                      <div>
                        <input type="file" class="file-input" formControlName="fileInput"
                          (change)="onFileSelected($event)" #fileUpload>
                          <button class="btn btn-outline-primary m-2 upload-file-styles" (click)="fileUpload.click()">Choose files</button>
                        </div>
                        @if (uploadedFileObjects.length === 0) {
                          <div class="font-sm-size d-flex"><span class="align-content-center">Select Files to Upload</span></div>
                        }
                      </div>
                      @if (uploadedFileObjects.length) {
                        <div [ngClass]="uploadedFileObjects.length > 6 ? 'upload-container': ''">
                          @for (eachFile of uploadedFileObjects; track eachFile) {
                            <div class="file-styles">
                              <div class="col-12 d-flex ">
                                <div class="d-flex">
                                  <div>
                                    <img src="images/document-icon.svg" class="pb-1 mr-4">
                                  </div>
                                  <div class="d-block">
                                    <div class="font-sm-size">{{eachFile.fileName}}</div>
                                    <div class="font-xs-size">{{eachFile.fileSize}} KB</div>
                                  </div>
                                </div>
                                <div class="ml-auto" (click)="removeSelectedFile(eachFile)">
                                  <img src="images/close-icon-upload.svg" class="pb-1">
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div class="d-flex">
                      <div class="font-xs-size ml-auto"> Max file size 200 MB</div>
                    </div>
                  </div>
                  @if (caseCreationForm.errors?.minTwoFilesRequired) {
                    <div class="font-sm-size col-12">
                      <div>Without proper documentation, carrier freight claims cannot be initiated.</div>
                      <div  class="CaseFiles"><ul><li>Photos/Videos of Damage (minimum 2 photos required)</li>
                      <li>Signed BOL/Delivery Receipt (must be documented with damaged item and piece count)</li></ul></div>
                      <div class="note"> <span class="font-text-bold">Note:</span> Separate cases must be entered for each shipment that contains damaged product.</div>
                    </div>
                  }
                }

              </ng-container>
              <div class="col-12 pl-0 mt-3">
                <div class="col-lg-2 pl-0 p-res-0 float-left">
                  <button type="button" class="w-100 mt-1 mt-sm-0 btn btn-outline-primary" (click)="goBack()">
                    Cancel
                  </button>
                </div>
                <div class="col-lg-2 pl-0 p-res-0 float-left">
                  <button type="button" (click)="submitForm()" class="w-100 mt-1 mt-sm-0 btn btn-primary" [disabled]="!(helperForm.valid && caseCreationForm.valid)">
                    Create Case
                  </button>
                </div>
              </div>
            </div>
          </div>
